import React from 'react';
import { useTranslation } from "react-i18next";
import DefaultFooter from "../components/default-footer";
import DefaultHeader from "../components/default-header";

const PrivacyPolicy = () => {
  const { t } = useTranslation();

  return (
    <>
      <style>{`
        /* ── PRIVACY POLICY STYLES ── */
        .privacy-wrap {
          background: #fff;
          border-radius: 20px;
          padding: 40px 44px;
          box-shadow: 0 8px 48px rgba(41,75,90,0.10);
        }
        .privacy-title {
          font-size: 28px;
          font-weight: 700;
          color: #1a2f38;
          margin-bottom: 8px;
        }
        .privacy-subtitle {
          font-size: 14px;
          color: #8aa5b0;
          margin-bottom: 32px;
        }
        .privacy-divider {
          height: 2px;
          background: linear-gradient(90deg, #294b5a 0%, #D3BE76 100%);
          border-radius: 2px;
          margin-bottom: 28px;
          width: 80px;
        }
        .privacy-section {
          margin-bottom: 32px;
        }
        .privacy-section:last-child {
          margin-bottom: 0;
        }
        .privacy-section-title {
          font-size: 18px;
          font-weight: 700;
          color: #1a2f38;
          margin-bottom: 12px;
          display: flex;
          align-items: center;
          gap: 10px;
        }
        .privacy-section-title .badge {
          font-size: 10px;
          font-weight: 600;
          color: #fff;
          background: #294b5a;
          padding: 2px 10px;
          border-radius: 20px;
          letter-spacing: 0.5px;
        }
        .privacy-section p {
          font-size: 14px;
          line-height: 1.8;
          color: #3d5a66;
          margin-bottom: 10px;
        }
        .privacy-section ul {
          list-style: none;
          padding: 0;
          margin: 8px 0 0 0;
        }
        .privacy-section ul li {
          font-size: 14px;
          line-height: 1.8;
          color: #3d5a66;
          padding-left: 20px;
          position: relative;
          margin-bottom: 4px;
        }
        .privacy-section ul li::before {
          content: "•";
          position: absolute;
          left: 0;
          color: #D3BE76;
          font-weight: 700;
        }
        .privacy-highlight {
          background: #f7fafc;
          padding: 16px 20px;
          border-radius: 10px;
          border-left: 3px solid #D3BE76;
          margin-top: 6px;
        }
        .privacy-highlight p {
          margin-bottom: 0;
        }
        .privacy-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 16px;
          margin-top: 8px;
        }
        .privacy-card {
          background: #f7fafc;
          padding: 16px 20px;
          border-radius: 10px;
          border-left: 3px solid #294b5a;
        }
        .privacy-card h4 {
          font-size: 14px;
          font-weight: 700;
          color: #1a2f38;
          margin-bottom: 4px;
        }
        .privacy-card p {
          font-size: 13px;
          color: #3d5a66;
          margin-bottom: 0;
          line-height: 1.6;
        }

        .privacy-company-badge {
          background: linear-gradient(135deg, #f7fafc 0%, #e8eef1 100%);
          border-radius: 12px;
          padding: 20px 24px;
          border: 1.5px solid #dde6ea;
          margin-bottom: 20px;
        }
        .privacy-company-badge h4 {
          font-size: 14px;
          font-weight: 700;
          color: #1a2f38;
          margin-bottom: 4px;
        }
        .privacy-company-badge p {
          font-size: 13px;
          color: #3d5a66;
          margin-bottom: 0;
        }

        .back-link {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          font-size: 13px;
          font-weight: 600;
          color: #294b5a;
          text-decoration: none;
          margin-bottom: 24px;
          transition: color 0.2s;
        }
        .back-link:hover {
          color: #D3BE76;
        }
        .back-link svg {
          width: 16px;
          height: 16px;
          stroke: currentColor;
          fill: none;
          stroke-width: 2.5;
        }

        @media (max-width: 768px) {
          .privacy-wrap { padding: 28px 20px; }
          .privacy-title { font-size: 22px; }
          .privacy-grid { grid-template-columns: 1fr; }
        }
      `}</style>

      <div className="header-margin"></div>
      <DefaultHeader />

      <section style={{ paddingTop: '20px' }}>
        <div className="container">
          <div className="row">
            <div className="col-12">

              {/* ── BACK LINK ── */}
              <a href="/" className="back-link">
                <svg viewBox="0 0 24 24">
                  <line x1="19" y1="12" x2="5" y2="12"/>
                  <polyline points="12 19 5 12 12 5"/>
                </svg>
                {t("backToHome", { defaultValue: "Back to Home" })}
              </a>

              {/* ── PRIVACY POLICY CONTENT ── */}
              <div className="privacy-wrap">

                {/* Heading */}
                <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "6px" }}>
                  <div style={{ width: "36px", height: "2px", background: "linear-gradient(90deg,#294b5a,#D3BE76)", borderRadius: "2px" }}></div>
                  <span style={{ fontSize: "11px", fontWeight: 700, color: "#294b5a" }}>{t("privacyPolicyLabel", { defaultValue: "Privacy Policy" })}</span>
                </div>
                <h1 className="privacy-title">{t("privacyTitle", { defaultValue: "Privacy Policy" })}</h1>
                <div className="privacy-divider"></div>

                {/* ── Company Info ── */}
                <div className="privacy-company-badge">
                  <h4>{t("companyInfo", { defaultValue: "Company Information" })}</h4>
                  <p>{t("companyInfoText", { defaultValue: "This privacy policy describes how SilverJarz Trading contracting (\"We\", \"Us\", \"Our\") collects, uses, and protects your personal information when you use the services provided at https://silverjarz.com" })}</p>
                  <p style={{ marginTop: "6px" }}>{t("companyInfoText2", { defaultValue: "silverjarz.com is a service platform owned and managed by SilverJarz Trading contracting, a licensed tourism company based in khasab musandam, OMAN (License No. 1213485). This website operates as an official part of our services, focusing on assisting individuals with visa applications and related tourism services." })}</p>
                </div>

                <p style={{ fontSize: "14px", color: "#3d5a66", marginBottom: "24px" }}>
                  {t("consentText", { defaultValue: "By using this website and our services, you agree to the collection and use of your personal information in accordance with this Privacy Policy." })}
                </p>

                {/* ── Section 1: Purpose of Data Collection ── */}
                <div className="privacy-section">
                  <div className="privacy-section-title">
                    {t("purposeTitle", { defaultValue: "Purpose of Data Collection" })}
                    <span className="badge">{t("dataCollection", { defaultValue: "Data Collection" })}</span>
                  </div>
                  <p>{t("purposeText", { defaultValue: "The primary purpose of collecting your personal data is to provide you with our services related to:" })}</p>
                  <ul>
                    <li>{t("purpose1", { defaultValue: "OMAN visit visa application assistance" })}</li>
                    <li>{t("purpose2", { defaultValue: "Tourism packages and holiday bookings" })}</li>
                    <li>{t("purpose3", { defaultValue: "Customer support and follow-up" })}</li>
                  </ul>
                  <div className="privacy-highlight">
                    <p>{t("purposeHighlight", { defaultValue: "We only collect data that is necessary to effectively provide these services and comply with legal requirements." })}</p>
                  </div>
                </div>

                {/* ── Section 2: Type of Information Collected ── */}
                <div className="privacy-section">
                  <div className="privacy-section-title">
                    {t("infoTypesTitle", { defaultValue: "Type of Information Collected" })}
                    <span className="badge">{t("information", { defaultValue: "Information" })}</span>
                  </div>
                  <p>{t("infoTypesText", { defaultValue: "To provide you with personalized and efficient services, we collect the necessary personal and technical data to process visa applications, improve services, and comply with legal requirements." })}</p>

                  <div className="privacy-grid">
                    <div className="privacy-card">
                      <h4>{t("personalInfo", { defaultValue: "Personal Information" })}</h4>
                      <p>{t("personalInfoText", { defaultValue: "Includes your name, email address, phone number, and other essential information important for processing visa applications and related government transactions." })}</p>
                    </div>
                    <div className="privacy-card">
                      <h4>{t("technicalData", { defaultValue: "Technical Data" })}</h4>
                      <p>{t("technicalDataText", { defaultValue: "Includes information such as your IP address, browser type, operating system, and access logs, which help us understand user behavior and improve website performance." })}</p>
                    </div>
                  </div>

                  <div style={{ marginTop: "12px" }}>
                    <p>{t("cookiesText", { defaultValue: "We use cookies and similar tracking technologies to personalize your experience and analyze website traffic. Cookies are small files stored on your device that help recognize returning visitors or remember preferences." })}</p>
                  </div>
                </div>

                {/* ── Section 3: How We Use Your Information ── */}
                <div className="privacy-section">
                  <div className="privacy-section-title">
                    {t("howWeUseTitle", { defaultValue: "How We Use Your Information" })}
                    <span className="badge">{t("usage", { defaultValue: "Usage" })}</span>
                  </div>
                  <ul>
                    <li>{t("use1", { defaultValue: "Your personal information is essential for facilitating visa applications or other government services." })}</li>
                    <li>{t("use2", { defaultValue: "We use your information to respond to inquiries, provide assistance, and improve our support services." })}</li>
                    <li>{t("use3", { defaultValue: "We analyze technical data to enhance website functionality and ensure a consistent user experience." })}</li>
                    <li>{t("use4", { defaultValue: "We may process your data to comply with legal and regulatory obligations." })}</li>
                  </ul>
                </div>

                {/* ── Section 4: Data Storage and Retention ── */}
                <div className="privacy-section">
                  <div className="privacy-section-title">
                    {t("storageTitle", { defaultValue: "Data Storage and Retention" })}
                    <span className="badge">{t("retention", { defaultValue: "Retention" })}</span>
                  </div>
                  <p>{t("storageText", { defaultValue: "Your data is securely stored on protected servers and access is limited to authorized personnel only. We retain your personal data for as long as necessary to:" })}</p>
                  <ul>
                    <li>{t("storage1", { defaultValue: "Fulfill the services you have requested" })}</li>
                    <li>{t("storage2", { defaultValue: "Meet legal or compliance obligations" })}</li>
                  </ul>
                  <div className="privacy-highlight" style={{ borderLeftColor: "#294b5a" }}>
                    <p>{t("storageHighlight", { defaultValue: "We retain personal data until we no longer need it, as required by OMAN law, after which it is securely deleted or anonymized." })}</p>
                  </div>
                </div>

                {/* ── Section 5: Data Sharing and Disclosure ── */}
                <div className="privacy-section">
                  <div className="privacy-section-title">
                    {t("sharingTitle", { defaultValue: "Data Sharing and Disclosure" })}
                    <span className="badge">{t("disclosure", { defaultValue: "Disclosure" })}</span>
                  </div>
                  <div className="privacy-highlight" style={{ borderLeftColor: "#e53935" }}>
                    <p><strong>{t("noSell", { defaultValue: "🚫 We do NOT sell or rent your personal information to any third party." })}</strong></p>
                  </div>
                  <p style={{ marginTop: "12px" }}>{t("sharingText", { defaultValue: "Your data may be shared with:" })}</p>
                  <ul>
                    <li>{t("share1", { defaultValue: "OMAN government departments involved in visa processing" })}</li>
                    <li>{t("share2", { defaultValue: "Payment processing partners (e.g., Stripe)" })}</li>
                    <li>{t("share3", { defaultValue: "Trusted tour and service partners under confidentiality agreements" })}</li>
                    <li>{t("share4", { defaultValue: "Legal authorities when required by OMAN law" })}</li>
                  </ul>
                </div>

                {/* ── Section 6: Cookies and Tracking ── */}
                <div className="privacy-section">
                  <div className="privacy-section-title">
                    {t("cookiesTitle", { defaultValue: "Cookies and Tracking Technologies" })}
                    <span className="badge">{t("tracking", { defaultValue: "Tracking" })}</span>
                  </div>
                  <p>{t("cookiesText2", { defaultValue: "Our website uses cookies to enhance your browsing experience and analyze usage. Cookies help us:" })}</p>
                  <ul>
                    <li>{t("cookie1", { defaultValue: "Remember your preferences" })}</li>
                    <li>{t("cookie2", { defaultValue: "Improve performance and user experience" })}</li>
                    <li>{t("cookie3", { defaultValue: "Collect anonymous visitor statistics (e.g., via Google Analytics)" })}</li>
                  </ul>
                  <p>{t("cookieOptOut", { defaultValue: "You can choose to disable cookies in your browser settings, but this may affect some website features." })}</p>
                </div>

                {/* ── Section 7: Microsoft Clarity ── */}
                <div className="privacy-section">
                  <div className="privacy-section-title">
                    {t("clarityTitle", { defaultValue: "Microsoft Clarity" })}
                    <span className="badge">{t("analytics", { defaultValue: "Analytics" })}</span>
                  </div>
                  <p>{t("clarityText", { defaultValue: "We use Microsoft Clarity to better understand how users interact with our website and to improve their overall experience. Clarity captures user behavior such as clicks, scrolls, and mouse movements through anonymized session recordings and heatmaps." })}</p>
                  <p>{t("clarityText2", { defaultValue: "Clarity may use cookies and other tracking technologies for this purpose. All data collected is anonymized and does not include personal information." })}</p>
                  <div className="privacy-highlight" style={{ borderLeftColor: "#294b5a" }}>
                    <p>{t("clarityConsent", { defaultValue: "By using our website, you consent to the processing of your data by Microsoft Clarity in accordance with Microsoft's Privacy Statement." })}</p>
                  </div>
                </div>

                {/* ── Section 8: Your Rights and Choices ── */}
                <div className="privacy-section">
                  <div className="privacy-section-title">
                    {t("rightsTitle", { defaultValue: "Your Rights and Choices" })}
                    <span className="badge">{t("yourRights", { defaultValue: "Your Rights" })}</span>
                  </div>
                  <p>{t("rightsText", { defaultValue: "You have specific rights regarding your personal data. You can request access to, update, and correct your personal information as appropriate." })}</p>
                  <ul>
                    <li>{t("right1", { defaultValue: "Request deletion of your personal information subject to legal and contractual obligations" })}</li>
                    <li>{t("right2", { defaultValue: "Unsubscribe from receiving our marketing communications at any time" })}</li>
                  </ul>
                  <div className="privacy-highlight" style={{ borderLeftColor: "#D3BE76" }}>
                    <p>{t("rightsContact", { defaultValue: "To exercise any of these rights, please contact our support team." })}</p>
                  </div>
                </div>

                {/* ── Section 9: Data Security ── */}
                <div className="privacy-section">
                  <div className="privacy-section-title">
                    {t("securityTitle", { defaultValue: "Data Security" })}
                    <span className="badge">{t("security2", { defaultValue: "Security" })}</span>
                  </div>
                  <p>{t("securityText", { defaultValue: "We take your privacy seriously. We implement technical and organizational safeguards to protect your data from unauthorized access, misuse, or loss. However, no digital system can guarantee 100% security." })}</p>
                </div>

                {/* ── Section 10: External Links ── */}
                <div className="privacy-section">
                  <div className="privacy-section-title">
                    {t("externalLinksTitle", { defaultValue: "External Links" })}
                    <span className="badge">{t("links", { defaultValue: "Links" })}</span>
                  </div>
                  <p>{t("externalLinksText", { defaultValue: "Our website may contain links to third-party websites. This Privacy Policy does not apply to those websites, and we are not responsible for their content or data handling practices." })}</p>
                </div>

                {/* ── Section 11: Policy Updates ── */}
                <div className="privacy-section">
                  <div className="privacy-section-title">
                    {t("updatesTitle", { defaultValue: "Policy Updates" })}
                    <span className="badge">{t("updates", { defaultValue: "Updates" })}</span>
                  </div>
                  <p>{t("updatesText", { defaultValue: "We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated effective date. Please review this page regularly to stay informed." })}</p>
                </div>

                {/* ── Section 12: Disclaimer ── */}
                <div className="privacy-section">
                  <div className="privacy-section-title">
                    {t("disclaimerTitle", { defaultValue: "Disclaimer" })}
                    <span className="badge">{t("disclaimer2", { defaultValue: "Disclaimer" })}</span>
                  </div>
                  <div className="privacy-highlight" style={{ borderLeftColor: "#294b5a", background: "#e8eef1" }}>
                    <p>{t("disclaimerText", { defaultValue: "We are a private sector advisory and facilitation service provider, operated by SilverJarz Trading contracting, a licensed tourism company based in khasab musandam, OMAN (License No. 2644940.01) for visa applications. We are not affiliated with any government entity and do not have the authority to approve or deny visa applications." })}</p>
                  </div>
                  <p style={{ marginTop: "12px" }}>{t("disclaimerText2", { defaultValue: "By using our website and services, you acknowledge and agree to the terms outlined in this Privacy Policy. Your trust is very important to us, and we are committed to protecting your personal information with the utmost care. We strive to make the visa application process smooth and secure." })}</p>
                  <div className="privacy-highlight" style={{ borderLeftColor: "#D3BE76" }}>
                    <p><strong>{t("commitment", { defaultValue: "Our Commitment:" })}</strong> {t("commitmentText", { defaultValue: "Our commitment to privacy ensures your personal information is handled according to the highest standards of security and confidentiality. Trust us to be a reliable partner in navigating the complexities of visa applications, providing you with expert guidance and support every step of the way." })}</p>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </section>

      <DefaultFooter />
    </>
  );
};

export default PrivacyPolicy;